export const tables = ['user', 'device', 'project', 'application', 'group', 'admin', 'all'];

export const voucherStatus = ['draft', 'live', 'ended'];

export const voucherCategory = ['individual','organization','promotion'];

export const subscriptionType = ['monthly','yearly'];

export const accountType = ["beginner","developer"];

export const planType = {
     beginner: ['beginner_monthly_1','beginner_yearly_1','beginner_yearly_1_bundle'],
     developer: ['developer_monthly_1','developer_yearly_1','developer_yearly_1_bundle']
}
export const duration = [1,3]

export const adminType = ["Ecosystem","Provider"]

export const planModel = ["Ecosystem Beginner","Ecosystem Developer","Enterprise Premise Beginner","Enterprise Premise Developer","Enterprise Cloud Beginner","Enterprise Cloud Developer"]

export const licenseType = ["none","perpetual"]

export const permissionLevel = ["1","2"]

export const hostingList =  ["favoriot","cloud","premise"]

export const tierist = ["T1 - Corporation","T2 - SME/EDU"]